import Icon from 'veui/components/Icon'
import { IconMute } from 'dls-icons-vue'

Icon.register('mute', IconMute)
